export default __webpack_public_path__ + "static/media/icons8-javascript.97852f20.svg";